import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { LoginAction } from "store/actions/AuthActions"
import { getProfileAction, updateProfileAction, uploadProfilePicture } from "store/actions/UserActions"
import { showFormErrors } from "utils/CommonFunctions"
import { checkBankErrors, checkErrors } from "utils/TableFunctions"
import formValidation from "utils/validations"

const ProfileContainer = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const { profile } = useSelector((state) => state.user)
    const [data, setData] = useState({
        fullName: "",
        category: "",
        distributor: "",
        publisher: "",
        aboutMe: "",
        profilePicture: ""
    })
    const [socialLinks, setSocialLinks] = useState([{ type: "", link: "" }])

    useEffect(() => {
        if (profile?._id) {
            setData({
                fullName: profile?.fullName,
                category: profile?.category,
                distributor: profile?.label,
                publisher: profile?.publisher,
                aboutMe: profile?.about,
                profilePicture: profile?.image
            })
            if (profile.socials) {
                setSocialLinks(profile.socials);
            }
        }
    }, [profile])

    const handleChange = ({ name, value }) => {
        const formErrors = formValidation(name, value, data)
        setData((prev) => ({ ...prev, [name]: value, formErrors }))
    }

    const onsubmit = async () => {
        const links = checkErrors(socialLinks, setSocialLinks, ["type", "link"])
        if (showFormErrors(data, setData) && !links.hasErrors) {
            dispatch(updateProfileAction(data, links?.values, setLoading, dispatch, navigate))
        }
    }

    return {
        data,
        socialLinks,
        setSocialLinks,
        handleChange,
        onsubmit,
        loading,
        setLoading
    }
}

export default ProfileContainer